<template>
  <div ref="tooltip" :style="styles" class="tooltip" :class="classes">
    {{ data.text }}
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Tooltip',
  props: {
    data: Object
  },
  data() {
    return {
      measuring: false,
      offsetX: 0,
      offsetY: 0
    };
  },
  computed: {
    ...mapGetters(['viewport/isMobile']),

    styles() {
      let styles = {
        left: this.position.x + 'px',
        top: this.position.y + 'px'
      };

      if (this.measuring) styles.opacity = 0;

      return styles;
    },
    position() {
      if (this.measuring) {
        return {
          x: this.data.x,
          y: this.data.y
        };
      } else {
        return {
          x: this.data.x + this.offsetX,
          y: this.data.y + this.offsetY
        };
      }
    },
    classes() {
      if (this.data.centerX && this.data.centerY) {
        return 'tooltip--centerBoth';
      } else if (this.data.centerX) {
        return 'tooltip--centerX';
      } else if (this.data.centerY) {
        return 'tooltip--centerY';
      } else return ''
    }
  },
  methods: {
    calculateOffsetToKeepOnScreen() {
      const boundingRect = this.$refs.tooltip.getBoundingClientRect();

      this.offsetX = -Math.max(boundingRect.right - window.innerWidth, 0);

      // WIP: Offset for the other 3 sides of the screen
    },
    measure() {
      this.measuring = true;

      this.$nextTick(() => {
        this.calculateOffsetToKeepOnScreen();
        this.measuring = false;
      });
    }
  },
  watch: {
    data: {
      handler() {
        this.measure();
      },
      immediate: true
    },
    isMobile() {
      this.measure();
    }
  }
};
</script>
<style scoped lang="scss">
.tooltip {
  pointer-events: none;
  overflow: visible;
  position: absolute;
  display: inline-block;
  color: white;
  font-size: 0.75rem;
  padding: 8px 10px;
  background-color: $grey-7;
  border: 1px solid white;
  border-radius: 10px;
  min-width: max-content;
  max-width: 500px;
  z-index: 999999;

  &--centerX {
    transform: translateX(-50%);
  }

  &--centerY {
    transform: translateY(-50%);
  }

  &--centerBoth {
    transform: translateX(-50%) transformY(-50%);
  }
}
</style>
